import entity from '../../../models/mlm/orders'

export default [
  {
    path: '/orders',
    meta: {
      entity,
      requiresPermissionTo: 'orders',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/orders/new',
    meta: {
      entity,
      requiresPermissionTo: 'orders',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/orders/:id',
    meta: {
      entity,
      requiresPermissionTo: 'orders',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
